/**
 * Work 템플릿 캔버스 (썸네일 모드) — 좌측 팔레트 추가 + 우측 정렬/이동/제거.
 * 라이브 렌더 미리보기/인라인 편집 없음. 폼 제출 시 인덱스 재번호만 수행.
 */
import { WorkTemplateBlocksBuilder } from "./WorkTemplateBlocksBuilder";

export class WorkTemplateThumbCanvas {
    readonly #root: HTMLElement;
    readonly #builder: WorkTemplateBlocksBuilder;
    #list: HTMLElement | null = null;

    constructor(root: HTMLElement) {
        this.#root = root;
        this.#builder = new WorkTemplateBlocksBuilder(root, {
            onStructureChange: () => this.#syncMoveState(),
        });
    }

    init(): void {
        this.#builder.init();
        this.#list = this.#builder.getList();

        const form = this.#root.querySelector<HTMLFormElement>("form.admin-form[data-admin-ajax='1']");
        if (form) this.#builder.bindSubmitReindex(form);

        if (!this.#list) return;
        this.#bindMoveButtons(this.#list);
        this.#bindFilter();
        this.#syncMoveState();
    }

    #bindMoveButtons(list: HTMLElement): void {
        list.addEventListener("click", (e) => {
            const target = (e.target as HTMLElement | null)?.closest<HTMLElement>("[data-work-blocks-move]");
            if (!target) return;
            e.preventDefault();
            e.stopPropagation();

            const dir = target.dataset.workBlocksMove;
            if (dir !== "up" && dir !== "down") return;

            const item = target.closest<HTMLElement>("[data-work-block-item]");
            if (!item) return;

            const sibling =
                dir === "up"
                    ? (item.previousElementSibling as HTMLElement | null)
                    : (item.nextElementSibling as HTMLElement | null);
            if (!sibling || !sibling.matches("[data-work-block-item]")) return;

            if (dir === "up") {
                list.insertBefore(item, sibling);
            } else {
                list.insertBefore(sibling, item);
            }

            this.#syncMoveState();
        });
    }

    #syncMoveState(): void {
        if (!this.#list) return;
        const items = Array.from(this.#list.querySelectorAll<HTMLElement>("[data-work-block-item]"));
        items.forEach((item, idx) => {
            const up = item.querySelector<HTMLButtonElement>('[data-work-blocks-move="up"]');
            const down = item.querySelector<HTMLButtonElement>('[data-work-blocks-move="down"]');
            if (up) {
                up.disabled = idx === 0;
                up.setAttribute("aria-disabled", up.disabled ? "true" : "false");
            }
            if (down) {
                down.disabled = idx === items.length - 1;
                down.setAttribute("aria-disabled", down.disabled ? "true" : "false");
            }
        });

        const empty = this.#list.querySelector<HTMLElement>("[data-work-blocks-empty]");
        if (empty) empty.hidden = items.length > 0;
    }

    #bindFilter(): void {
        const input = this.#root.querySelector<HTMLInputElement>("[data-work-blocks-thumb-filter]");
        if (!input) return;
        input.addEventListener("input", () => {
            const q = input.value.trim().toLowerCase();
            this.#root.querySelectorAll<HTMLElement>("[data-work-blocks-palette-item]").forEach((cell) => {
                const hay = (cell.dataset.searchText ?? "").toLowerCase();
                cell.hidden = q.length > 0 && !hay.includes(q);
            });
        });
    }
}
